import type { Icons } from "@/components/icons";

export type Product = {
  contactPerson: any;
  photo_url: string;
  name: string;
  description: string;
  created_at: string;
  price: number;
  id: number;
  category: string;
  updated_at: string;
};

export interface NavItem {
  title: string;
  url: string;
  disabled?: boolean;
  external?: boolean;
  shortcut?: [string, string];
  icon?: keyof typeof Icons;
  label?: string;
  description?: string;
  isActive?: boolean;
  items?: NavItem[];
  id: string;
}

//Info: The following data is used for the sidebar navigation and Cmd K bar.
export const navWorkspace: NavItem[] = [
  {
    title: "Map",
    url: "/dashboard/map",
    icon: "mapPin",
    isActive: false,
    id: "map",
    shortcut: ["m", "m"],
    items: [], // Empty array as there are no child items for Dashboard
  },
  {
    title: "Organisations",
    url: "/dashboard/organisations",
    icon: "building",
    shortcut: ["p", "p"],
    isActive: false,
    items: [], // No child items
    id: "organisations",
  },
  {
    title: "Data",
    url: "/dashboard/data",
    icon: "data",
    shortcut: ["p", "p"],
    isActive: false,
    items: [], // No child items
    id: "data",
  },
  {
    title: "Projects",
    url: "/dashboard/projects",
    icon: "folderCheck",
    shortcut: ["p", "p"],
    isActive: false,
    items: [], // No child items
    id: "projects",
  },
  {
    title: "Opportunities",
    url: "/dashboard/opportunities",
    icon: "briefcase",
    shortcut: ["p", "p"],
    isActive: false,
    items: [], // No child items
    id: "opportunities",
  },
  {
    title: "Team",
    url: "/dashboard/users",
    icon: "user2",
    shortcut: ["p", "p"],
    isActive: false,
    items: [], // No child items
    id: "users",
  },

  {
    title: "Settings",
    url: "/dashboard/settings",
    icon: "folderCog",
    shortcut: ["p", "p"],
    isActive: false,
    items: [], // No child items
    id: "settings",
  },
  {
    title: "Inquiries",
    url: "/dashboard/inquiries",
    icon: "messageSquare",
    shortcut: ["i", "i"],
    isActive: false,
    items: [], // No child items
    id: "inquiries",
  },

  // {
  //   title: 'Help',
  //   url: '/dashboard/help',
  //   icon: 'messageSquare',
  //   shortcut: ['p', 'p'],
  //   isActive: false,
  //   items: [] // No child items
  // }
];
export const navOrganisation: NavItem[] = [
  {
    title: "Map",
    url: "/dashboard/map",
    icon: "mapPin",
    isActive: false,
    shortcut: ["m", "m"],
    items: [], // Empty array as there are no child items for Dashboard
    id: "map",
  },
  {
    title: "Organisations",
    url: "/dashboard/organisations",
    icon: "building",
    shortcut: ["p", "p"],
    isActive: false,
    items: [], // No child items
    id: "organisations",
  },

  {
    title: "Projects",
    url: "/dashboard/projects",
    icon: "folderCheck",
    shortcut: ["p", "p"],
    isActive: false,
    items: [], // No child items
    id: "projects",
  },
  {
    title: "Team",
    url: "/dashboard/users",
    icon: "user2",
    shortcut: ["p", "p"],
    isActive: false,
    items: [], // No child items
    id: "users",
  },
  {
    title: "Opportunities",
    url: "/dashboard/opportunities",
    icon: "briefcase",
    shortcut: ["p", "p"],
    isActive: false,
    items: [], // No child items
    id: "opportunities",
  },
  {
    title: "Setttings",
    url: "/dashboard/settings",
    icon: "folderCog",
    shortcut: ["p", "p"],
    isActive: false,
    items: [], // No child items
    id: "set-up",
  },

  {
    title: "Help",
    url: "/dashboard/help",
    icon: "messageSquare",
    shortcut: ["p", "p"],
    isActive: false,
    items: [], // No child items
    id: "help",
  },
];

export interface SaleUser {
  id: number;
  name: string;
  email: string;
  amount: string;
  image: string;
  initials: string;
}

export const recentSalesData: SaleUser[] = [
  {
    id: 1,
    name: "Olivia Martin",
    email: "olivia.martin@email.com",
    amount: "+$1,999.00",
    image: "https://api.slingacademy.com/public/sample-users/1.png",
    initials: "OM",
  },
  {
    id: 2,
    name: "Jackson Lee",
    email: "jackson.lee@email.com",
    amount: "+$39.00",
    image: "https://api.slingacademy.com/public/sample-users/2.png",
    initials: "JL",
  },
  {
    id: 3,
    name: "Isabella Nguyen",
    email: "isabella.nguyen@email.com",
    amount: "+$299.00",
    image: "https://api.slingacademy.com/public/sample-users/3.png",
    initials: "IN",
  },
  {
    id: 4,
    name: "William Kim",
    email: "will@email.com",
    amount: "+$99.00",
    image: "https://api.slingacademy.com/public/sample-users/4.png",
    initials: "WK",
  },
  {
    id: 5,
    name: "Sofia Davis",
    email: "sofia.davis@email.com",
    amount: "+$39.00",
    image: "https://api.slingacademy.com/public/sample-users/5.png",
    initials: "SD",
  },
];
